import { Sparkles, Loader } from "lucide-react";

/**
 * DemoRibbon — sticky bottom CTA that appears on demo Bio hubs only.
 * "Use as starting point" clones the demo hub's theme + blocks into the
 * visitor's own hub. Uses --ux-z-sticky-cta so the share sheet
 * (--ux-z-modal) can still float on top of it.
 */
export function DemoRibbon({ hubTheme, cloning, onOpenClonePreview }) {
  return (
    <div
      className="fixed left-0 right-0 px-3 pb-[calc(0.75rem+env(safe-area-inset-bottom,0))]"
      style={{ bottom: 0, zIndex: "var(--ux-z-sticky-cta)" }}
      data-testid="demo-hub-cta-ribbon"
    >
      <div
        className="max-w-3xl mx-auto rounded-2xl text-cream p-3 sm:p-4 flex items-center gap-3"
        style={{ background: "var(--ux-ink)", boxShadow: "var(--ux-shadow-2)" }}
      >
        <div
          className="w-10 h-10 rounded-xl bg-coral flex items-center justify-center flex-shrink-0"
          style={{ border: "1px solid rgba(255,255,255,0.25)" }}
        >
          <Sparkles className="w-5 h-5 text-white" strokeWidth={2.5} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-display font-black text-sm sm:text-base tracking-tight leading-tight">
            Like this hub? Make it yours.
          </p>
          <p className="text-[11px] sm:text-xs text-cream/70 leading-tight mt-0.5">
            Clone the {hubTheme} theme + every block into your own Web Link in one tap.
          </p>
        </div>
        <button
          type="button"
          onClick={onOpenClonePreview}
          disabled={cloning}
          data-testid="demo-hub-clone-btn"
          className="rounded-full bg-coral text-white px-3.5 py-2 font-semibold text-xs uppercase tracking-wide flex items-center gap-1.5 disabled:opacity-70 whitespace-nowrap"
          style={{ border: "1px solid rgba(255,255,255,0.25)" }}
        >
          {cloning ? (
            <>
              <Loader className="w-3.5 h-3.5 animate-spin" /> Cloning…
            </>
          ) : (
            <>Use as starting point</>
          )}
        </button>
      </div>
    </div>
  );
}
